import BaseInteriorScene from "../BaseInteriorScene";
import merchantCollisions from "../../../@shared/assets/GameMap/voidMerchant.json";
// import merchantCollisions from "../../../@shared/assets/GameMap/defaultArenaInterior.json";
import voidMerchantBG from "../../../@shared/assets/GameMap/voidMerchant.png";
import { getVoidCityNpcDialogue } from "../../../@shared/utils/npcDialogs";

export default class VoidCityMerchant extends BaseInteriorScene {
  constructor() {
    super(
      "MerchantScene",
      merchantCollisions,
      voidMerchantBG,
      {
        exit: { to: "VillageScene", spawnAt: { x: 718, y: 234 } },
      },
      getVoidCityNpcDialogue
    );
  }
}
